import { createSlice } from "@reduxjs/toolkit";
import { ratingreviewdetailsAPI } from "../../api/ratingreview";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const ratingreviewdetailsSlice = createSlice({
  name: "ratingreviewdetails",
  initialState: data,
  reducers: {
   ratingreviewdetailsSlice(state) {
      state.isLoading = true;
    },
   ratingreviewdetailsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    ratingreviewdetailsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    ratingreviewdetailsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const ratingreviewdetailsHandler: any = (id:any) => async (dispatch: any) => {
  try {
    dispatch(getCustomersDetailsAction.ratingreviewdetailsSlice());
    const response: any = await ratingreviewdetailsAPI(id);
    
    dispatch(getCustomersDetailsAction.ratingreviewdetailsSliceSuccess(response));
  } catch (e: any) {
    dispatch(getCustomersDetailsAction.ratingreviewdetailsSliceFailure(e?.response?.data));
  }
};
export default ratingreviewdetailsSlice.reducer;
export const getCustomersDetailsAction = ratingreviewdetailsSlice.actions;
